export enum ESupplyStatus {
  Created = 'created',
  Pending = 'pending',
  Processing = 'processing',
  Approved = 'approved',
  Delivery = 'delivery',
  Delivered = 'delivered',
  Cancelled = 'cancelled',
}

export enum ESupplyStatusLabel {
  created = 'На согласовании',
  pending = 'Согласовано',
  processing = 'Обрабатывается',
  approved = 'Ждет отгрузки',
  delivery = 'Заказ в пути',
  delivered = 'Заказ доставлен',
  cancelled = 'Не согласовано',
}

export enum ESupplyGroupType {
  Date = 'date',
  Group = 'group',
  Data = 'data',
}
